const BE_COUNTRY_CODE = '+32';

export function formatTelHref(raw: string | undefined | null): string {
  if (!raw) return '#';
  const compact = raw.replace(/[\s.\-()]/g, '');
  if (compact.startsWith('+')) return `tel:${compact}`;
  const national = compact.startsWith('0') ? compact.slice(1) : compact;
  return `tel:${BE_COUNTRY_CODE}${national}`;
}

// International form for structured data: "010 60 15 71" gives
// "+32 10 60 15 71". The national groups stay as they are typed.
export function formatInternationalPhone(
  raw: string | undefined | null,
): string {
  const text = (raw || '').trim().replace(/\s+/g, ' ');
  if (!text || text.startsWith('+')) return text;
  const national = text.startsWith('0') ? text.slice(1).trim() : text;
  return `${BE_COUNTRY_CODE} ${national}`;
}
